// «Сообщить об ошибке» (К-17, FR-PLAY-09): работает и у анонимного аккаунта; офлайн — отправится позже.
import { useState } from "react";
import { db } from "../lib/db.ts";
import { enqueue, flush } from "../lib/pending.ts";
import { api } from "../state/app.ts";
import { t } from "../i18n/ru.ts";
import { Sheet } from "./Sheet.tsx";

export type ComplaintDraft = { content_id: string; content_version: number; step?: string };

export function ComplaintSheet({ draft, onClose }: { draft: ComplaintDraft; onClose: () => void }) {
  const [kind, setKind] = useState("wrong_explanation");
  const [comment, setComment] = useState("");
  const [done, setDone] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    const key = await enqueue(db, "/v1/complaints", { ...draft, kind, comment: comment.trim() || undefined });
    const left = await flush(api, db);
    setDone(left.has(key) ? t.complaint.queued : t.complaint.thanks);
    setBusy(false);
  };
  return (
    <Sheet title={t.complaint.title} onClose={onClose}>
      {done ? (
        <>
          <p>{done}</p>
          <button className="btn btn--primary" onClick={onClose}>
            {t.common.close}
          </button>
        </>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void send();
          }}
        >
          <fieldset className="radio-list">
            {Object.entries(t.complaint.kinds).map(([k, label]) => (
              <label key={k}>
                <input type="radio" name="kind" value={k} checked={kind === k} onChange={() => setKind(k)} /> {label}
              </label>
            ))}
          </fieldset>
          <label className="field">
            <span>{t.complaint.comment}</span>
            <textarea maxLength={1000} rows={4} value={comment} onChange={(e) => setComment(e.target.value)} />
          </label>
          <button className="btn btn--primary" disabled={busy}>
            {t.complaint.send}
          </button>
        </form>
      )}
    </Sheet>
  );
}
